module.exports = __webpack_public_path__ + "static/media/default-new-logo.417a0b8f.svg";